import { Box, Input } from "@drone-js/core";
import { getAgoda } from "libs/analytics/functions/agoda.homes";
import type { FunctionComponent } from "react";
import styled from "styled-components";

export interface ErrorStack {
    instance: Error;
}

const MonoInput = styled(Input)`
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
    font-size: 12px !important;
`;

export const ErrorStackRenderer: FunctionComponent<ErrorStack> = ({ instance }) => {
    if (!getAgoda().isInternalUser) return null;

    return (
        <Box maxWidth="848px" width="100%">
            <MonoInput
                label="Error stack"
                rows={10}
                type="textarea"
                clearLabel="Clear"
                disabled
                value={`${instance.stack}`}
            />
        </Box>
    );
};
